<template>
  <div>

    <!--div id="snackbar">{{snackbar_alert_msg}}</div-->

    <v-snackbar
      v-model="$store.state.gen.showSnack"
    >


      <div>
        <div
        >
          {{line1}}
        </div>
        <div
        >
          {{line2}}
        </div>
      </div>


      <v-btn
        color="pink"
        flat
        @click="$store.state.gen.showSnack = false"
      >
        Close
      </v-btn>
    </v-snackbar>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  //
  let vm
  //
  export default {
    data () {
      return {
        line1: '',
        line2: ''
      }
    },
    computed:{
      ...mapGetters([
        'snackbar_alert_msg'
      ])
    },
    methods: {
      msgText () {
        vm = this
        //
        let msg = this.$store.state.gen.snackbar_alert_msg
        console.log(`alert message: `, msg)
        //alert(msg)
        if (msg.includes(`Please sign-in to add to your travel list`)) {
          //alert(`1`)
          this.line1 = `Please sign in to complete your desired action.`
          this.line2 = ``
        }
        else if (msg.includes(`Please sign-in to like it.`)) {
          //alert(`2`)
          this.line1 = `Please sign in to complete your desired action.`
          this.line2 = ``
        }
        else if (msg.includes(`Please sign-in to complete this action.`)) {
          //alert(`3`)
          this.line1 = `Please sign in to complete your desired action.`
          this.line2 = ``
        }
        else {
          this.line1 = msg
          this.line2 = ''
        }
        //
      }
    },
    watch: {
      '$store.state.gen.showSnack': () => {
        //alert(`0`)
        if (vm.$store.state.gen.showSnack) {
          vm.msgText()
        }
      }
    },
    created () {
      vm = this
    }
  }
</script>

<style scoped>
  #snackbar {
    visibility: hidden;
    min-width: 250px;
    margin-left: -125px;
    background-color: #333;
    color: orange;
    text-align: center;
    border-radius: 2px;
    padding: 16px;
    position: fixed;
    z-index: 1;
    left: 50%;
    bottom: 30px;
    font-size: 17px;
  }

  #snackbar.show {
    visibility: visible;
    -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
    animation: fadein 0.5s, fadeout 0.5s 2.5s;
  }

  @-webkit-keyframes fadein {
    from {bottom: 0; opacity: 0;}
    to {bottom: 30px; opacity: 1;}
  }

  @keyframes fadein {
    from {bottom: 0; opacity: 0;}
    to {bottom: 30px; opacity: 1;}
  }

  @-webkit-keyframes fadeout {
    from {bottom: 30px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
  }

  @keyframes fadeout {
    from {bottom: 30px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
  }
</style>



// WEBPACK FOOTER //
// snackbar_alert.vue?44fe8654